/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';

export default function UserOptionsCardMessage({ user, closeModal }) {
  const [smsMessage, setSmsMessage] = useState('');

  const targetUser = user?.user;
  const username = targetUser?.username || '';
  const phoneNumber = targetUser?.phone || '';
  const displayName = `${targetUser?.firstName || ''} ${targetUser?.lastName || ''}`.trim() || username || 'User';

  const handleSendDirectSMS = () => {
    if (!phoneNumber) {
      toast.error('User phone number is not available');
      return;
    }
    if (!smsMessage.trim()) {
      toast.error('SMS message content is required');
      return;
    }

    const messageText = encodeURIComponent(smsMessage.trim());
    const smsUrl = `sms:${phoneNumber}?&body=${messageText}`;

    closeModal();
    window.location.href = smsUrl;
  };

  return (
    <Box sx={{ p: 1 }}>
      <Typography variant="h6" sx={{ fontWeight: 800, mb: 0.5, color: '#111827' }}>
        Send Direct SMS / Local Message
      </Typography>
      <Typography variant="body2" sx={{ color: '#6B7280', mb: 2.5 }}>
        Sends a direct text message to <strong>{displayName}</strong>&apos;s registered phone number.
      </Typography>

      <Stack spacing={2}>
        <TextField
          fullWidth
          label="Recipient Phone Number"
          disabled
          value={phoneNumber || 'No phone number registered'}
          size="small"
        />

        <TextField
          fullWidth
          label="SMS Content"
          placeholder="Type SMS text message content here..."
          multiline
          rows={4}
          value={smsMessage}
          onChange={(e) => setSmsMessage(e.target.value)}
        />
      </Stack>

      <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Button variant="outlined" color="inherit" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSendDirectSMS}
          disabled={!phoneNumber || !smsMessage.trim()}
          sx={{ bgcolor: '#2563EB', '&:hover': { bgcolor: '#1D4ED8' } }}
        >
          Send Direct SMS
        </Button>
      </Stack>
    </Box>
  );
}

UserOptionsCardMessage.propTypes = {
  user: PropTypes.object,
  closeModal: PropTypes.func,
};
